// Sentry initialization — web
//
// Inert until REACT_APP_SENTRY_DSN is set in the environment. Safe to ship
// without the DSN; just won't collect errors. Wire the DSN in Vercel project
// env vars when ready.
//
// SOC 2 mapping: CC7.2 (System Operations — monitoring) starting evidence.

// Shell — inert until @sentry/react is installed and REACT_APP_SENTRY_DSN is set.
// To activate: npm install @sentry/react, set DSN in Vercel env vars, then replace
// this file with the real init (see docs/runbooks for Sentry onboarding steps).
// SOC 2 mapping: CC7.2 (System Operations — monitoring) starting evidence.

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[sentry] REACT_APP_SENTRY_DSN not set — Sentry disabled.');
    }
    return;
  }
  // DSN is set but package not yet installed — log a clear reminder.
  console.warn('[sentry] REACT_APP_SENTRY_DSN is set but @sentry/react is not installed. Run: npm install @sentry/react');
}
